// Maps a SIM's ICCID to its network operator via the ICCID's IIN (issuer
// identification number) prefix - operator isn't stored anywhere, it's always
// derived from the ICCID like this. Shared by GatewaysList and SystemDetails
// so the mapping only lives in one place.
const OPERATORS_BY_ICCID_PREFIX: Record<string, string> = {
	'894801': 'Plus',       // Polkomtel
	'894802': 'T-Mobile',   // PTC
	'894803': 'Orange',     // PTK Centertel
	'894804': 'Plus',       // CenterNet
	'894805': 'Orange',     // PTK Centertel (UMTS)
	'894806': 'Play',       // P4
	'894807': 'Netia',
	'894808': 'EXATEL',     // E-Telko
	'894809': 'Lycamobile',
	'894810': 'T-Mobile',   // Sferia
	'894811': 'Plus',       // Nordisk Polska
	'894812': 'Cyfrowy Polsat',
	'894813': 'Move Telecom', // Sferia
	'894814': 'Sferia',
	'894815': 'CenterNet',
	'894816': 'Plus',       // Mobyland
	'894817': 'Plus',       // Aero 2
	'894818': 'AMD Telecom',
	'894819': 'Teleena',
	'894820': 'Mobile.Net',
	'894821': 'Exteri',
	'894822': 'Arcomm',
	'894823': 'Amicomm',
	'894824': 'IT Partners Telco', // WideNet
	'894825': 'thulium',    // BS&T
	'894826': 'ATE',
	'894827': 'Intertelcom',
	'894828': 'CrossMobile', // PhoneNet
	'894829': 'SMSWIZARD Polska', // Interfonica
	'894830': 'GrandTel',
	'894831': 'T-Mobile',   // Phone IT
	'894832': 'Compatel',
	'894833': 'Truphone',
	'894834': 'T-Mobile',   // NetWorkS! (T-Mobile/Orange network-sharing JV)
	'894898': 'Play',       // Play test network
	'8937101': 'LMT',       // Latvian Mobile Telephone Co. (Latvia)
	'8942020': 'O2',        // O2 Czech Republic
};

export const getSimOperator = (iccid: string | null | undefined): string | null => {
	if (!iccid) return null;
	return OPERATORS_BY_ICCID_PREFIX[iccid.slice(0, 6)] ?? OPERATORS_BY_ICCID_PREFIX[iccid.slice(0, 7)] ?? 'unknown';
};
